import { reduxForm, formValueSelector } from 'redux-form';
import { fetchWarehouses, searchWarehouses, selectWarehouse, resetCurrentWarehouse, deleteWarehouse, editWarehouseDefault } from '../../actions/warehouses_actions';
import { connect } from 'react-redux';

import Warehouses from '../../components/Inventories/warehouses'

const warehouses = reduxForm({
    form: 'warehouses',
})(Warehouses);

const selector = formValueSelector('warehouses')

function mapStateToProps(state) {
    const nameValue = selector(state, 'WarehouseName');
    return {
        nameValue,

        updated: state.warehouses.updated,
        warehouses: state.warehouses.all,
        currentWarehouses: state.warehouses.currentWarehouse,
        initialValues: state.warehouses.currentWarehouse,
        isLoading: state.warehouses.isLoading,
        error: state.warehouses.error,
        currentWarehouse: state.warehouses.currentWarehouse,
        deleteWarehouse: state.warehouses.deleteWarehouse,
        deleteWarehouseSuccess: state.warehouses.deleteWarehouseSuccess,
        deleteWarehouseError: state.warehouses.deleteWarehouseError,
    };
}

export default connect(mapStateToProps, { fetchWarehouses, selectWarehouse, resetCurrentWarehouse, searchWarehouses, deleteWarehouse, editWarehouseDefault })(warehouses);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/warehouses.jsx